import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Chip,
  IconButton,
  Rating
} from '@mui/material';
import {
  LocationOn,
  Favorite,
  FavoriteBorder,
  Landscape
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const FeaturedProperties = () => {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [favorites, setFavorites] = useState(new Set());

  // Mock data for featured properties
  useEffect(() => {
    const mockProperties = [
      {
        _id: '1',
        title: 'Prime Residential Plot - Kitengela',
        price: 1500000,
        location: 'Kitengela, Kajiado',
        area: 0.25, // acres
        images: ['https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80&auto=format&fit=crop'],
        type: 'Residential Land',
        rating: 4.8,
        featured: true,
        user_id: 'demo-user-1'
      },
      {
        _id: '2',
        title: 'Commercial Land Near Tarmac - Ruiru',
        price: 5500000,
        location: 'Ruiru, Kiambu',
        area: 0.5,
        images: ['https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1200&q=80&auto=format&fit=crop'],
        type: 'Commercial Land',
        rating: 4.9,
        featured: true,
        user_id: 'demo-user-1'
      },
      {
        _id: '3',
        title: 'Fertile Agricultural Acreage - Nanyuki',
        price: 3200000,
        location: 'Nanyuki, Laikipia',
        area: 5,
        images: ['https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=1200&q=80&auto=format&fit=crop'],
        type: 'Agricultural Land',
        rating: 4.6,
        featured: true,
        user_id: 'demo-user-1'
      }
    ];
    setProperties(mockProperties);
  }, []);

  const toggleFavorite = (propertyId) => {
    setFavorites(prev => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(propertyId)) {
        newFavorites.delete(propertyId);
      } else {
        newFavorites.add(propertyId);
      }
      return newFavorites;
    });
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Property cards will be added here */}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturedProperties;
